var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"home-view",attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"4","md":"4"}},[_c('service-status-card')],1),_c('v-col',{attrs:{"cols":"8","md":"8"}},[_c('uyap-status-card',{staticClass:"mb-2"}),_c('usage-guide-card')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }